<div class="activity-section" *transloco="let t">
  @if (dateRange(); as dateRange) {
    <p class="pl-6 text-gray-700">
      {{ t("sp-strategy-group-page.activities_registered_within_selected_date_range") }}
      <b>{{
        (dateRange[0] | date: "mediumDate" : undefined : locale()) +
          " " +
          t("day-parting-inputs.to_hours") +
          " " +
          (maxActivitiesDate() | date: "mediumDate" : undefined : locale())
      }}</b>
    </p>
  }
  <app-strategy-activity-component [strategy]="strategy()"></app-strategy-activity-component>
</div>
